export const categories = {
    televisions: {
        brands: ["Samsung", "Sony", "LG", "Akira", "Hisense", "Century"],
        prices: [
            "Below $500",
            "$500 - $2,000",
            "$2,000 - $5,000",
            "Above $5,000"
        ],
        data: [
            {
                id: 1,
                name:
                    "Samsung 65'' QLED Curved 4K HDR 1500 Smart Quantum Dot TV",
                brand: "Samsung",
                desc: `Introducing QLED TV, the most spectacular Samsung TV yet. An
                    unbelievably brilliant picture made possible by over a billion colors,
                    producing images you have to see to believe. With 100% color volume thanks
                    to Samsung's proprietary Quantum dots, picture quality and color volume
                    have been elevated beyond any prior Samsung product.
                    As smart as it is beautiful, the new Smart TV knows what’s 
                    connected and lets you control everything with one remote.`,
                price: 3025,
                img:
                    "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/13/904913/1.jpg?9028",
                qty: 4,
                year: '2020',
                rating: 4,
            },
            {
                id: 2,
                name: "Sony 85'' UHD 4K SMART Android LED TV-85X8500G",
                brand: "Sony",
                desc: `4K UHD (Resolution: 3840 x 2160), Connectivity - Input: 4*HDMI, 3*USB
                    TRILUMINOS Display, 4K HDR Processor X1, 4K X-Reality PRO,
                    Android TV, Chromecast built-in, ClearAudio+, Motionflow XR 800 (Native 100Hz)
                    Warranty Information: 1 year seller warranty, Wall Mount & installation 
                    SCREEN SIZE 85''{138.8CM}, RESOLUTION 3480*2160, SMART TV, UHD 4K TV, 3 USB, 3 HDMI, AV
                    `,
                price: 4425,
                img:
                    "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/14/604444/1.jpg?6026",
                year: '2018',
                qty: 12,
                rating: 3
            },
            {
                id: 3,
                name: '4K Smart TV 43"',
                brand: 'Smart',
                price: 580,
                img: 'https://i.ebayimg.com/images/g/J1QAAOSwISJe1VCN/s-l1600.jpg',
                desc: `Response time of 8ms, Refresh rate of 60HZ, Cortex A53 Quad Core 1.5GHz 
                    CPU, Mali-450 750MHz GPU, 1GB RAM, 8GB ROM, WIFI Support, Bluetooth Support, IR Support`,
                year: '2019',
                qty: 5,
                rating: 4,
            },
            {
                id: 4,
                name: `Hisense - 32`,
                brand: 'Hisense',
                price: 480,
                img: 'https://paysmall.africa/wp-content/uploads/2020/03/32-INCHES.jpg',
                desc: `Screen size is 32 inches, Maximum Resolution is 720p (HD), Wall Mountable, LED`,
                year: '2018',
                qty: 38,
                rating: 5,
            },
            {
                id: 5,
                name: `Samsung M4500 32 inch 768p HD LED`,
                brand: 'Samsung',
                price: 520,
                img: 'https://i.ebayimg.com/images/g/nhMAAOSwZXFfF~Na/s-l640.jpg',
                desc: `Resolution 720p. HD 720p: enjoy a viewing experience with 2x the clarity and detail.
                 Versus dual-core processor. Display Technology LED. Display LED.`,
                year: '',
                qty: 6,
                rating: 4,
            },
            {
                id: 6,
                name: `VIZIO D50x-G9 50” Class 4K Ultra HD 2160P HDR Smart LED TV - Black`,
                brand: 'Vizio',
                price: 668,
                img: 'https://i5.walmartimages.com/asr/5bc8d959-7ff9-4d78-8193-8bfc291a6ac3_2.27c85b7991f468f79d18ed145d36c7c5.jpeg',
                desc: `Refresh Rate 60Hz, Maximum Resolution is 2160p (4K) USB, Other features include Digital Audio Coaxial RCA, Digital Audio Optical TOSLINK, Composite Video RCA, HDMI`,
                year: '2018',
                qty: 6,
                rating: 5,
            },
            {
                id: 7,
                name: `Samsung TU7000 50" 4K LED Smart TV`,
                brand: 'Samsung',
                price: 540,
                img: 'https://i.ebayimg.com/images/g/XdoAAOSwrtteeg8V/s-l640.jpg',
                desc: `Wi-Fi Enabled, Wall Mountable, Max Resolution 2160p, Internet Streaming Interface, Home Network Streaming, Internet Browsing`,
                year: '2019',
                qty: 10,
                rating: 5,
            },
            {
                id: 8,
                name: `Samsung TU7000 65" Class HDR 4K UHD Smart LED TV`,
                brand: 'Samsung',
                price: 800,
                img: 'https://i.ebayimg.com/images/g/PBUAAOSwUQBe75Ys/s-l500.jpg',
                desc: `View your favorite content at four times the resolution of 1080p with the Samsung TU7000 65" Class HDR 4K UHD Smart LED TV. This TV has a 64.5" LCD panel and incorporates Motion Rate 120 technology to digitally enhance fast-moving images to reduce blur. It is compatible with the HDR10, HDR10+, and HLG HDR formats to provide a wider color gamut with compatible content and source equipment for more vivid images. 

                The TU7000 has built-in Wi-Fi, Ethernet, and AirPlay 2 connectivity to allow access to your favorite apps and internet-based content, plus content sharing and screen mirroring with your other smart devices such as your smartphone or tablet.`,
                year: '2019',
                qty: 16,
                rating: 5,
            },
            {
                id: 9,
                name: `LG 49LJ5500 49" 1080p LED Internet TV`,
                brand: 'LG',
                price: 550,
                img: 'https://www.lg.com/us/images/tvs/md05810749/gallery/LJ5500_Small_Left.jpg',
                desc: `Refresh Rate: 60Hz, Audio/Video Inputs: HDMI Features: Wi-Fi Enabled, Bluetooth, 2 Port USB Hub, Ethernet Port, Wall Mountable`,
                year: '2017',
                qty: 6,
                rating: 4,
            },
            {
                id: 10,
                name: `Smart TV Samsung Ue43tu7105 43' 4k Ultra HD LED WiFi Grigio`,
                brand: 'Samsung',
                price: 545,
                img: 'https://i.ebayimg.com/images/g/2JAAAOSw0vVfR~qJ/s-l640.jpg',
                desc: `4K Ultra HD. WIFI 5 Ghz. Inches: 43'. Technology: LED`,
                year: '2020',
                qty: 3,
                rating: 5,
            },
        ]
    },
    "gas-cookers": {
        brands: ["Nulec", "Skyrun", "Scanfrost", "Beko"],
        prices: ["Below $50", "$50 - $100", "$100 - $150", "Above $150"],
        data: [
            {
                id: 1,
                name: "Nexus 4-Burner Gas Cooker",
                price: 30,
                brand: '',
                desc: '',
                img: 'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/04/431631/1.jpg?7980',
                year: '2015',
                qty: 6,
                rating: 3
            },
            {
                id: 2,
                name: "Skyrun 4gas Cooker With Gas Oven",
                price: 130,
                brand: '',
                desc: '',
                img:
                    "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/37/496444/1.jpg?9980",
                qty: 12,
                year: '2017',
                rating: 4
            },
            {
                id: 3,
                name: "Scanfrost 4 Burners Gas Oven Cooker-",
                price: 153,
                brand: '',
                desc: '',
                img:
                    "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/95/528043/1.jpg?3625",
                year: '2016',
                qty: 8,
                rating: 5
            },
            {
                id: 11,
                name: `Maxi GAS And ELECTRIC COOKER`,
                brand: 'Maxi',
                price: 375,
                img: 'https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/63/659702/1.jpg?2895',
                desc: `60cm x 90cm . 4 Gas Burners, 2 Electrical Burners . Glass & Stainless Steel . Ignition Button . Oven Lamp . Timer`,
                year: '2019',
                qty: 6,
                rating: 4,
            },
            {
                id: 12,
                name: `Beko Gas Cooker FSET63110DX`,
                brand: 'Beko',
                price: 470,
                img: 'https://ng.jumia.is/unsafe/fit-in/680x680/filters:fill(white)/product/53/392254/1.jpg?4115',
                desc: `It has an electric oven with grill . Fan assistance cooking . Flame failure device . push button ignition . oven capacity 71 liters`,
                year: '2018',
                qty: 10,
                rating: 4,
            },
            {
                id: 4,
                name: `Polystar 4Gas Burner 1 Hot Plate`,
                brand: 'Polystar',
                price: 425,
                img: 'https://ng.jumia.is/unsafe/fit-in/680x680/filters:fill(white)/product/56/859313/1.jpg?2550',
                desc: `Full stainless steel . Glass cover . Auto Ignition . Flapping drawer
                Cast iron grates
                Timer
                Gas oven`,
                year: '2018',
                qty: 6,
                rating: 4,
            },
            {
                id: 5,
                name: `Maxi Free Standing Gas Cooker`,
                brand: 'Maxi',
                price: 441.5,
                img: 'https://ng.jumia.is/unsafe/fit-in/680x680/filters:fill(white)/product/55/950554/1.jpg?3824',
                desc: `Gas : 4 Burners (pipe System) . Hot Plate : 1000 W & 1500 W . Oven Burner : Up & Down . Push Button Ignition : Hobs & Oven
                . Timer (for black gray) . Tray + Wire Grid
                Oven Lamp . Glass LID . Double Oven Glass – Elite design . 1 year warranty`,
                year: '2019',
                qty: 6,
                rating: 4,
            },
            {
                id: 6,
                name: `Scanfrost 4 Burners Gas Oven Cooker`,
                brand: 'Scanfrost',
                price: 152.5,
                img: 'https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/95/528043/1.jpg?3625',
                desc: `4 Gas Burners-Lamp . Gas Oven with Grey Finish . Classic Home Look . Black Matte finish . Double Glass insulated Door . Oven lamp . Oven Tray . With 2 Years PAN Nigeria Warranty`,
                year: '2019',
                qty: 6,
                rating: 4,
            },
            {
                id: 7,
                name: 'Skyrun Gas Cooker',
                img: 'https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/87/054074/1.jpg?3712',
                price: 135,
                brand: 'Skyrun',
                year: '2018',
                qty: 16,
                rating: 4,
            },
        ],
    },
    cars: {
        data: [
            {
                id: 1,
                name: `2020 Ford Mustang Shelby GT500`,
                brand: 'Ford',
                price: 105490,
                img: 'https://i.ebayimg.com/images/g/JowAAOSwRk9fTUZq/s-l500.jpg',
                desc: `BLACK INDOOR CAR COVER (DEALER INSTALLED), CARBON FIBER TRACK PACK, EQUIPMENT GROUP 950A, PAINTED OVER-THE-TOP RACING STRIPES, TECHNOLOGY PACKAGE, ENGINE: 5.2L SUPERCHARGED V8, TRANSMISSION: TREMEC 7-SPEED DCT`,
                year: '2020',
                qty: 3,
                rating: 5,
            },
            {
                id: 2,
                name: `2008 Ford Mustang`,
                brand: 'Ford',
                price: 42000,
                img: 'https://i.ebayimg.com/images/g/KyIAAOSwHlFfTYYU/s-l1600.jpg',
                desc: `Drive Side: Left-hand drive, Transmission: Manual
                       Power Options: Air Conditioning, Cruise Control, Power Windows, Power Locks, For Sale By: Private Seller
                Interior Color: Black, Warranty: Vehicle does NOT have an existing warranty
                Drive Type: RWD, Fuel Type: Gasoline
                Sub Model: Shelby GT500, Exterior Color: Orange
                Vehicle Title: Clean, Options: CD Player, Leather Seats
                Safety Features: Driver Airbag, Passenger Airbag, Anti-Lock Brakes, Body Type: Coupe`,
                year: '2008',
                qty: 6,
                rating: 4,
            },
            {
                id: 11,
                name: `2020 Jeep Compass`,
                brand: 'Jeep',
                price: 23770,
                img: 'https://cdn.jdpower.com/JDPA_2020%20Jeep%20Compass%20Limited%20Red%20Front%20View.jpg',
                desc: `Back-Up Camera, Cruise Control (Optional),
                Adaptive Cruise Control (Optional), Vehicle Anti-Theft System, Fog Lamps, Auto-Off Headlights, HID headlights (Optional),
                    Keyless StartRear Parking Aid (Optional), Power Liftgate (Optional), Remote Engine Start`,
                year: '2020',
                qty: 6,
                rating: 5,
            },
            {
                id: 3,
                name: `2000 Ford Super Duty F-350`,
                brand: 'Ford',
                price: 27900,
                img: 'https://i.ebayimg.com/images/g/QsUAAOSwaSRfSutc/s-l500.jpg',
                desc: `Engine: 8 Cylinder Engine, Body Type: Pickup (Truck),
                Options: CD player, 4-Wheel drive
                Transmission: Manual, Doors:4`,
                year: '2000',
                qty: 6,
                rating: 3,
            },
            {
                id: 4,
                name: `2020 Chevrolet Corvette`,
                brand: 'Chevrolet',
                price: 85000,
                img: 'https://i.ebayimg.com/images/g/yOUAAOSwv8pfTbC4/s-l1600.jpg',
                desc: `Options: ENGINE, 6.2L V8 DI, HIGH-OUTPUT, Power Options: Steering, power, magnetic rack-and-pinion
                Trim: 2LT, Transmission: Automatic,
                Drive Type: 2dr Stingray Cpe w/2LT,
                Engine: 8 Cylinder Engine 6.2L,
                Fuel Type: Gasoline`,
                year: '2020',
                qty: 2,
                rating: 5,
            },
            {
                id: 5,
                name: `2009-Mercedes-Benz-G-Class-G-550`,
                brand: 'Mercedes',
                price: 36800,
                img: 'https://i.ebayimg.com/images/g/rjUAAOSwlsNfQxeT/s-l1600.jpg',
                desc: `Body Type: SUV, Drive Type: 4WD,
                Model: G-Class, Engine: 5.5L V8 DOHC 32V,
                Number of Cylinders: 8,, Exterior Color: Black,
                Number of Doors: 4 Doors,
                Sub Model: G 550 4MATIC® 4dr SUV, Fuel Type: Gasoline
                Transmission: Automatic,, Interior Color: Brown`,
                year: '2009',
                qty: 12,
                rating: 4,
            },
            {
                id: 6,
                name: `2020 Jeep Wrangler SAHARA`,
                brand: 'Jeep',
                price: 31500,
                img: 'https://i.ebayimg.com/images/g/RTMAAOSwmKdfRX-U/s-l1600.jpg',
                desc: `Body Type: SUV, Model: Wrangler,
                    Number of Cylinders: 4,, Sub Model: SAHARA,
                    Transmission: Automatic,, Doors: 4,
                    Safety Features: Driver Side Airbag, Passenger Side Airbag, Power Options: Air Conditioning, Cruise Control
                    Fuel Type: Gasoline`,
                year: '2020',
                qty: 6,
                rating: 4,
            },
            {
                id: 7,
                name: `2010-BMW-X6-M`,
                brand: 'BMW',
                price: 39000,
                img: 'https://i.ebayimg.com/images/g/KfIAAOSwmThfDztv/s-l1600.jpg',
                desc: `
                Year: 2010, VIN (Vehicle Identification Number): 5YMGZ0C55ALK13433
                Mileage: 13529, Engine: 4.4
                Options: NAVIGATION, HEATED SEATS, COOLED SEATS, EXECUTIVE PACKAGE, TECHNOLOGY PACKAGE, CD Player, Leather Seats, Sunroof, 
                Model: X6
                Power Options: Air Conditioning, Cruise Control, Power Locks, Power Windows, Power Seats, Safety Features: Anti-Lock Brakes, Driver Airbag, Passenger Airbag, Side Airbags
                Number of Cylinders: 8, Drive Side: Left-hand drive,
                Transmission: Automatic`,
                year: '2010',
                qty: 22,
                rating: 4,
            },
            {
                id: 8,
                name: `2013-Cadillac-Escalade-Platinum-4X4`,
                brand: 'Cadillac',
                price: 17900,
                img: 'https://i.ebayimg.com/images/g/I4cAAOSwOBhfQH9O/s-l1600.jpg',
                desc: `
                Options: 4-Wheel Drive, CD Player, Leather Seats, Sunroof,
                Power Options: Air Conditioning, Cruise Control, Power Locks, Power Windows, Power Seats, Safety Features: Anti-Lock Brakes, Driver Airbag, Passenger Airbag, Side Airbags
                Number of Cylinders: 8, Drive Side: Left-hand drive,
                Transmission: Automatic`,
                year: '2013',
                qty: 10,
                rating: 4,
            },
            {
                id: 9,
                name: `2017 Chevrolet Suburban`,
                brand: 'Chevrolet',
                price: 23000,
                img: 'https://i.ebayimg.com/images/g/yJ0AAOSwFK1fRqpq/s-l1600.jpg',
                desc: ``,
                year: '',
                qty: 6,
                rating: 4,
            },
        ]
    },
    refrigerators: {
        data: [
            {
                id: 1,
                name: 'Haier Thermocool Double Door Fridge',
                brand: 'Haier Thermocool',
                price: 325,
                img: 'https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/38/501116/1.jpg?4328',
                desc: `Capacity: 95L . Energy Saving . Super Fast Cooling . Stabilizer Free Operation . Adjustable Thermostat . LED Interior Lighting`,
                year: '2018',
                qty: 13,
                rating: 4,
            },
            {
                id: 2,
                name: 'Haier Thermocool Single Door',
                brand: 'Haier Thermocool',
                price: 220,
                img: 'https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/72/999016/1.jpg?2154',
                desc: `Colour: White . Capacity: 142 Litres . Super Freezing Function . Extra-Density Insulation`,
                year: '2018',
                qty: 20,
                rating: 4,
            },
            {
                id: 3,
                name: 'Haier Thermocool 150L Chest Freezer',
                brand: 'Haier Thermocool',
                price: 313.75,
                img: 'https://ng.jumia.is/unsafe/fit-in/680x680/filters:fill(white)/product/24/716373/1.jpg?3108',
                desc: `This Haier Thermocool Small Chest Freezer 150 INTC R6 WHT with model HT FREEZER CHEST SML 150 INTC R6 WHT
                    Its low noise operation helps maintain a quieter environment.
                    It also comes with one detachable basket compartment to store vegetables, fruits, and other foodstuff. Haier Thermocool products are known to be tested and trusted.
                    Haier Thermocool Small Chest Freezer HTF-150 WHT has a 150-Litres net capacity. This small chest freezer comes with an extreme cooling function, it has a reversible door that swings open and close.
                    This product is very portable and stylish. This means it does not take a lot of space,  also does not take the style from the décor. It fits in totally with the arrangement.`,
                year: '2018',
                qty: 20,
                rating: 4,
            },
            {
                id: 4,
                name: 'Hisense 100 LITERS REF100DR',
                brand: 'Hisense',
                img: 'https://www.decorhubng.com/wp-content/uploads/2017/05/BC-100-O.gif',
                price: 150,
                desc: `The Hisense Chest Freezer is also a very reliable alternative offering you high performance in freezing your food items to keep them fresh, very efficient low energy consumption with an amazing low noise design. It has a mechanical temperature control and an adjustable thermostat for efficient freezing function which gets everything in it so cool very fast, it still stays cool and this way it gets to preserve your perishable food items for a very long time.`,
                qty: 10,
                rating: 5,
            },
            {
                id: 5,
                name: 'LG Refrigerator 131',
                brand: 'LG',
                img: 'https://ng.jumia.is/unsafe/fit-in/680x680/filters:fill(white)/product/63/873512/1.jpg?7120',
                price: 168.75,
                desc: `LG Refrigerator 131 will help all your food, vegetables and other perishables fresh for a long period of time. It will not only keep your food in perfect condition, but it will keep your water and drinks chilled. When you come need to quench your thirst after a long day, you can trust to get this refrigerator to give you chilled drinks. There is an ice tray in the fridge for you to make ice for your drinks. The two wire shelves of this refrigerator will allow you store all kinds of food and vegetables. They will remain fresh and crisp for a long period of time.`,
                qty: 10,
                rating: 5,
            },
            {
                id: 6,
                brand: 'Hisense',
                name: 'Hisense FAST FREEZE Chest Freezer',
                img: 'https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/93/759702/1.jpg?2897',
                price: 270,
                desc: `This Chest Freezer is a functional and essential product from the fine selection of varied high quality freezers by Hi sense . It comes with a design that meets the demand of style and practicality for a long lasting and efficient use.`,
                qty: 10,
                rating: 5,
            }
        ]
    }
};
